<template>
		<div class = "box">
			<ComNar title = "中杯通兑券"></ComNar>
			<div class="content-box">
				<div class="head-box">
					<img class="head-img" src="@/assets/hint.png" mode="" />
					<div class="text-1">该券获取后<span>当日有效</span></div>
					<div class="text-2">请在门店点餐时再获取二维码，出示店员核销</div>
				</div>
				
				<div class = "pay-phone-detail-div">
					<div class = "pay-phone-cell-div">
						<van-field v-model="phone"  :disabled="sUserInfo.mobile!=null && sUserInfo.mobile.length == 11" type="digit" label="文本" input-align="right" placeholder="请输入手机号"  maxlength="11">
							<template #label>
							  <div class = "pay-phone-div">
								 <div>联系电话</div>
							  </div>
							</template>
						</van-field>
					</div>
					<PhoneCode v-if="!sUserInfo.mobile" @setCode = "updateCode" :phone = "phone" @success="success"></PhoneCode>
				</div>
				
				<div class="btn-box">
					<van-button class="btn" text="我已知晓（今日使用）" round :color="this.$enum.CONSTANT.APP_THEME_COLOR" @click="payCoupon()" />
					<van-button class="btn" text="取消（下次使用）" round :color="this.$enum.CONSTANT.APP_THEME_COLOR" to="home" />
				</div>
				<div class="hint-box-head">
				  —— 使用规则 ——
				</div>
				<div class="hint-box-content">
					<p>1.到店出示卡券由门店机具扫描验证后即可兑换。星巴克全国指定直营门店可用（臻选店，机场店，火车站等交通枢纽和景区门店除外）</p>
					<p>2.仅适用于中国大陆地区指定星巴克门店对外销售的现场手工调制标准配方(中杯355ml，非定制)饮品(不包括瓶装饮料、星巴克臻选咖啡系列、星巴克气致冷萃咖啡、虹吸壶冲泡咖啡和咖啡融合冰淇淋系列等部分特定饮品)</p>
				</div>
			</div>
		
			<!-- <van-action-sheet v-model="showPayType" :round="false" :closeable="false">
				<PayType :orderId="orderId" :orderPayType="1" :code="code" @success = "doSuccess" @loadCode="loadNowCode()"></PayType>
			</van-action-sheet> -->
		</div>
</template>
<script>
	import ComNar from '@/components/searchShop/ComNar.vue'
	import PhoneCode from '@/components/pay/PhoneCode.vue'
	import {Col, Row,Field,Cell,CellGroup,Button,Notify,		ActionSheet,} from 'vant';
	import PayType from '@/components/pay/PayType.vue'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	import {
		addOrder,
		getBalancePay,
		getWeixinPay,
	} from '@/request/api';
	export default {
		data() {
			return {
				orderId : null,
				phone:'',
				smsCode:'',
				showPayType:false,
				code:'',
			}
		},
		computed: mapGetters(["sUserInfo"]),
		components:{
			[ComNar.name]: ComNar,
			[Button.name]: Button,
			[ActionSheet.name]: ActionSheet,
			[Col.name]: Col,
			[Row.name]: Row,
			[Field.name]: Field,
			[PhoneCode.name]: PhoneCode,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Notify.name]: Notify,
			[PayType.name]: PayType
		},
		created() {
			this.getPhone();
		},
		methods: {
			...mapMutations(['setOrderId','setOrderCode']),
			loadNowCode(){
				let browserFlag = this.isWechat()
				if (browserFlag == 0) {
					let code = this.$getUrlParam("code")
					if (!code && !this.sOrderCode) {
						this.getCode()
					} else {
						if(code){
							this.setOrderCode(code)
							this.code = code;
							let uri =  window.location.href
							uri = uri.split("?")[0]+'#/historyOrder'
							window.location.replace(uri)
						}else{
							this.code = this.sOrderCode
							this.setOrderCode('')
						}
					}
				}
			},
			success(){
				// this.$emit('success')
			},
			getUrlParam(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
				let url = window.location.href.split('#')[0]
				let search = url.split('?')[1]
				if (search) {
					var r = search.substr(0).match(reg)
					if (r !== null) return unescape(r[2])
					return null
				} else {
					return null
				}
			},
			doSuccess(){
				if(this.orderId){
					this.setOrderId(this.orderId);
					this.$router.push({
						name: 'orderDetail',
						params: {
							orderId: this.orderId
						}
					})
				}
				// this.$emit('loadCode')
			},
			getCode() {
				// console.log(window.location.href)
				let payBack = window.location.href;
				let appId = "wx3de49bcab72a4020"
				// 测试环境公众号ID
				// let appId="wxeade3e34841010b2"
				let codeUri = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" +
					encodeURIComponent(payBack) + "&response_type=code&scope=snsapi_base#wechat_redirect"
				window.location.href = codeUri
			},
			isWechat() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					return 0
				} else {
					return 1
				}
			},
			// 购买用户券
			payCoupon(){
					if(this.sUserInfo.mobile){
						addOrder({
							"phone": this.sUserInfo.mobile,
							"orderType" : 2
						}).then(res => {
							// this.orderId = res;
							// this.showPayType = true;
							this.$router.push({
								name: 'OrderPay',
								query: {
									orderId: res
								}
							})
						})
					}else{
						//滚动条
						Notify({ type: 'danger', message: '请绑定手机' });
					}
					
				// this.$router.replace({
				// 	name: 'orderHint',
				// 	query: {id:'1927'}
				// })
				// return;
				// let now = new Date()
				// let nowHour = parseInt(now.getHours())
				// let nowMin = parseInt(now.getMinutes())
				// if(nowHour>=21){
				// 	this.$router.push("unSell");
				// 	return
				// }
				// if(nowHour < 8){
				// 	this.$router.push("unSell");
				// 	return
				// }
				
			},
			// success(){
			// 	this.$emit('success')
			// },
			getPhone(){
				this.phone = this.sUserInfo.mobile;
			},
			updateCode(code){
				this.smsCode = code
			},
			
			
		}
	}
</script>
<style scoped>
	.box {
		width: 100%;
		height: 100%;
		background: #f6f6f6;
	}
	.iframeStyle{
		    width: 100%;
			height: calc(100% - 50px)
	}
	.content-box{
		width: 100%;
		padding: 0 18px;
		text-align: center;
		background: #f6f6f6;
	}
	.head-box{
		text-align: center;
		color: #CEA559;
	}
	.head-box .head-img{
		width: 170px;
		height: 60px;
		margin: 40px auto 30px auto;
		
	}
	.text-1{
		font-size: 22px;
	}
	.text-1 span{
		color: #006E3F;
	}
	.text-2 {
		font-size: 16px;
		padding-top: 5px;
	}
	.btn-box{
		display: flex;
		justify-content: space-between;
		margin: 20px 0;
	}
	.btn-box .btn{
		width: 49%;
		font-size: 13px;
	}
	.hint-box-head{
		font-size: 19px;
		color: #2A6750;
		margin-bottom: 20px;
	}
	.hint-box-content{
		text-align: left;
		padding: 15px 0;
	}
	.pay-phone-detail-div{
		padding-top: 15px;
	}
</style>
